<div class="loading-dialog">
  <span class="loading-text">{{ data.loadingText }}</span>
  <mat-spinner [diameter]="36"></mat-spinner>
</div>
